
export const getAddressCompany = (shopAddress = {}) => {
  const { street = '4820 Pyrenees Pass, Austin', city = 'TX', state = '78738', country = 'USA' } = shopAddress
  return [street, city, state, country].filter(str => str.trim()).join(', ')
}